import { render, staticRenderFns } from "./OtherTechnicalFeatures.vue?vue&type=template&id=1c305df8"
import script from "./OtherTechnicalFeatures.vue?vue&type=script&lang=js"
export * from "./OtherTechnicalFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports